// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__GavBh","card":"Cards_card__C8YVm","infected":"Cards_infected__35Lhj","recovered":"Cards_recovered__2dKcb","deaths":"Cards_deaths___2-QN"};